import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.scss']
})
export class PageNotFoundComponent implements OnInit {

currentUser: any;
databaseId: string;
organizationId: string;
responseHolder: any;

constructor(private statusConst: StatusConstant, private loaderService: LoaderService,
  private toastr: ToastrService,
  private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses) {

  // const encryptedtoken = sessionStorage.getItem('userToken');
  // this.databaseId = sessionStorage.getItem('databaseId')?? '';
  //  this.organizationId = sessionStorage.getItem('organizationID')?? '';
  // const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
  // this.currentUser = jwt_decode(token);
}

ngOnInit(): void {
  
}

}
